import Modal from '@components/ui/Modal'
import styles from './styles.module.scss'
import { Button } from '@components/ui/Button'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'
import { useRouter } from 'next/router'
import { prefixLocale } from '@helpers/env'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { useState } from 'react'

function LayoutAccountLoggedOutModal() {
  const { login } = useLogin()
  const [selected, setSelected] = useState(false)
  const router = useRouter()

  const handleLoginClick = () => {
    if (!selected) {
      setSelected(true)
      login()
    }
  }

  return (
    <Modal openedModal={true}>
      <div className={styles.accountModal}>
        <h1>Time to Log In or Sign Up!</h1>
        <p>
          Returning or new? You’re in the right place! Enjoy secure,
          password-less access to your account.
        </p>
        <div className={styles.buttonsWrapper}>
          <Button variant="primary" onClick={handleLoginClick}>
            Let’s go!
          </Button>
          <ButtonMinimal
            classes={styles.homeButton}
            onClick={() => router.push(`${prefixLocale()}/`)}
            underlined={true}
          >
            Continue shopping
          </ButtonMinimal>
        </div>
      </div>
    </Modal>
  )
}

export default LayoutAccountLoggedOutModal
